import {toast} from 'react-toastify';
import {ASSET_CATEGORY, PAGE_MODE, SERVER_URL, SERVICE_SUBCATEGORY} from "./Constants";
// import {LoginService} from "../service/LoginService";

// const loginService = new LoginService();
export default class GeneralUtils {
    static isNullOrEmpty(value) {
        return (!value || value === undefined || value === "" || value.length === 0 || JSON.stringify(value) === JSON.stringify({}));
    }

    static __isValueEmpty(value) {
        switch (typeof value) {
            case "undefined":
                return true;
            case "object":
                if (value === null) return true;
                return Object.keys.length === 0;
            case "string":
                return (value === undefined || value === null || value.trim() === "");
            default:
                break;
        }
    }

    // Returns if a value is an object
    static isObject(value) {
        return value && typeof value === 'object' && value.constructor === Object;
    }


    static checkPasswordFormat(str) {
        var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
        return re.test(str);
    }

    static logout(data){
        fetch(SERVER_URL + -'login/logout', {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(data)
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    static checkUnauthorized(response) {
        switch (response.status) {
            case 200:
                break;
            case 401 :
                let data = {eventType: "TIMEOUT"};
                GeneralUtils.logout(data);
                localStorage.clear();
                window.location.href = "/login";
                break;
            default:
                toast.error("Beklenmeyen bir hata oluştu. Hata kodu: " + response.status);
                break;
        }
    }

    static notification(response) {
        switch (response.status) {
            case 200:
                response.json().then(function (notification) {
                    if (notification.type) {
                        GeneralUtils.showNotification(notification);
                    } else {
                        toast.success("İşlem başarıyla gerçekleştirilmiştir.");
                    }
                });
                break;
            case 401 :
                response.json().then(function (notification) {
                    if (notification.type) {
                        GeneralUtils.showNotification(notification);
                    } else {
                        toast.warn("Bu işlem için yetkilendirme gereklidir. Lütfen hesabınıza giriş yapınız.");
                    }
                });
                break;
            case 403 :
                response.json().then(function (notification) {
                    if (notification.type) {
                        GeneralUtils.showNotification(notification);
                    } else {
                        toast.warn("Erişim reddedildi. Bu sayfaya erişim yetkiniz bulunmamaktadır.");
                    }
                });
                break;
            default:
                toast.error("Beklenmeyen bir hata oluştu. Hata kodu: " + response.status);
                break;
        }
    }

    static notification(response, hiddenSucces) {
        switch (response.status) {
            case 200:
                response.json().then(function (notification) {
                    if (notification.type) {
                        GeneralUtils.showNotification(notification);
                    } else {
                        if(!hiddenSucces) {
                            toast.success("İşlem başarıyla gerçekleştirilmiştir.");
                        }
                    }
                });
                break;
            case 401 :
                response.json().then(function (notification) {
                    if (notification.type) {
                        GeneralUtils.showNotification(notification);
                    } else {
                        toast.warn("Bu işlem için yetkilendirme gereklidir. Lütfen hesabınıza giriş yapınız.");
                    }
                });
                break;
            case 403 :
                response.json().then(function (notification) {
                    if (notification.type) {
                        GeneralUtils.showNotification(notification);
                    } else {
                        toast.warn("Erişim reddedildi. Bu sayfaya erişim yetkiniz bulunmamaktadır.");
                    }
                });
                break;
            default:
                toast.error("Beklenmeyen bir hata oluştu. Hata kodu: " + response.status);
                break;
        }
    }

    static showNotification(notification) {
        switch (notification.type) {
            case "SUCCESS":
                toast.success(notification.message);
                break;
            case "INFO" :
                toast.info(notification.message);
                break;
            case "WARNING" :
                toast.warn(notification.message);
                break;
            case "ERROR":
                toast.error(notification.message);
                break;
            default:
                toast.error("Beklenmeyen bir hata oluştu. " + notification.message);
                break;
        }
    }

    static addCreateInfo(data) {
        // data.createdBy = this.getUserId();
        // data.createdDate = new Date();
        return data;
    }

    static addUpdateInfo(data) {
        // data.lastModifiedBy = this.getUserId();
        // data.lastModifiedDate = new Date();
        return data;
    }

    static getContactId() {
        var userLocalStorage = JSON.parse(localStorage.getItem("uUser"));
        return (!this.__isValueEmpty(userLocalStorage)) ? userLocalStorage.contactId.id : null;
    }

    static getUser() {
        var userLocalStorage = JSON.parse(localStorage.getItem("uUser"));
        return (!this.__isValueEmpty(userLocalStorage)) ? userLocalStorage : null;
    }
    static getUserId() {
        var userLocalStorage = JSON.parse(localStorage.getItem("uUser"));
        return (!this.__isValueEmpty(userLocalStorage)) ? userLocalStorage.id : null;
    }

    static getUserTitle() {
        var userLocalStorage = JSON.parse(localStorage.getItem("uUser"));
        return (!this.__isValueEmpty(userLocalStorage)) ? userLocalStorage.title : null;
    }


    static compareIndex = (a, b) => {
        return a.objectIndex - b.objectIndex;
    }
}
